import { getStore } from '../App';
import actions from '../redux/actions';

export const messageSuccess = (message, duration) => {
  getStore().dispatch(actions.alertMessageSuccess({ message, duration }));
};
export const messageError = (message, duration) => {
  getStore().dispatch(actions.alertMessageError({ message, duration }));
};
